import { Col, Row } from 'react-bootstrap';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';

const UserSummaryRow = ({ fields }) => {
  const { tempedgeTranslator } = useTempEdgeTranslator();

  return (
    <Row className="form-group justify-content-center user-summary-row">
      {fields.map(({ key, labelKey, value }) => (
        <Col key={key} xs={12} md={4}>
          <span className="control-label">{tempedgeTranslator(labelKey)}</span>
          <span className="control-text-user">{value}</span>
        </Col>
      ))}
    </Row>
  );
};

export default UserSummaryRow;
